export const getLegend = (state) => state.map.legend;
export const getCurrentFeature = (state) => state.map.currentFeature;
export const getMeasurerActive = (state) => state.map.measurerActive;
export const getBaseMapsOpen = (state) => state.map.baseMapsOpen;
export const getBaseMapsName = (state) => state.map.baseMapsName;
export const getOverlayFeature = (state) => state.map.overlayFeature;
